module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('article', {
    attrs: {
      "epub:type": "chapter"
    }
  }, [_c('div', {
    staticClass: "bodymatter",
    attrs: {
      "epub:type": "bodymatter"
    }
  }, [_c('section', {
    attrs: {
      "epub:type": "division"
    }
  }, [_c('h1', {
    staticClass: "chapter_fm1",
    attrs: {
      "id": "c11"
    }
  }, [_c('span', {
    staticClass: "chapter_fm1"
  }, [_vm._v("c. 126")])]), _vm._v(" "), _c('h1', {
    staticClass: "chapter01"
  }, [_vm._v("Roman Concrete")]), _vm._v(" "), _c('p', {
    staticClass: "seealso_fm2"
  }, [_c('strong', [_vm._v("Pliny the Elder")]), _vm._v(" (23−79)")]), _vm._v(" "), _c('p', {
    staticClass: "nonindent"
  }, [_vm._v("Concrete is everywhere in our civilization; modern construction wouldn’t be possible without it. But its chemistry is surprisingly complex, depending on two elements (aluminum and silicon) that form strong bonding networks with oxygen atoms. These species, which are abundant in Earth’s crust, form the basis for a huge variety of minerals and man-made ceramics. Concrete also requires calcium ions and a reaction with water to help hold everything together, but the technical name, "), _c('em', [_vm._v("hydrated calcium aluminosilicate")]), _vm._v(", although an accurate description of concrete’s chemical composition, doesn’t roll off the tongue very easily.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The Romans had the finest concrete of the ancient world, and some of it can still be seen today in such magnificent structures as the famous Pantheon—completed around the year 126 and still the largest unreinforced concrete dome in the world. Roman civilization, though, was actually “science deficient”; considering their power and longevity, surprisingly little basic research was done. They didn’t have much patience for mathematics, blue-sky experimentation, or abstract theories, but practical improvements in civil and military engineering were always welcome. As such, the Romans developed a variety of concrete mixtures for different applications. Their water-resistant mix was of very high quality, and according to the natural philosopher Pliny the Elder, a key ingredient in the mortar was the ashy volcanic deposits (now known as "), _c('em', [_vm._v("pozzolan")]), _vm._v(") from the area of Mount Vesuvius. Pliny knew the area well—too well, in the end, since he was killed in the famous 79 eruption that destroyed Pompeii.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Just in the last few years, analytical chemists have been able to work out how this recipe for Roman maritime concrete must have been made. The process requires quite a bit less energy than modern Portland cement, which was developed in nineteenth-century Britain. In terms of the fuel needed to bake the starting limestone mix, the time needed to cure the finished product, and its durability in salt water, the Roman recipe has many advantages. After almost two thousand years, it may be making a comeback.")]), _vm._v(" "), _c('p', {
    staticClass: "seealso"
  }, [_c('strong', [_vm._v("SEE ALSO")]), _vm._v(" "), _c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/Text/c12"
    }
  }, [_vm._v("Porcelain (c. 200)")])]), _vm._v(" "), _c('div', {
    staticClass: "image"
  }, [_c('div', {
    staticClass: "dis_img"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "Images/035.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("The two-thousand-year-old Pantheon in Rome still has the largest unreinforced concrete dome in the world—a solid testament to Roman engineering.")])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-700472d6","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/c11.vue
// module id = 108
// module chunks = 0